import React from 'react';
import {Route, Routes, useLocation} from "react-router-dom";
import {AnimatePresence} from "framer-motion";
import NavigationPage from "../pages/NavigationPage";
import MainMenu from "../pages/MainMenu";
import Drinks from "../pages/Drinks";
import FastFood from "../pages/FastFood";
import Alcohol from "../pages/Alcohol";

const AnimRoutes = () => {
    const location = useLocation();

    return (
        <AnimatePresence initial={true} mode={'wait'}>
            <Routes key={location.pathname} location={location}>
                <Route path={'/'} element={<NavigationPage/>}></Route>
                <Route path={'/main-menu'} element={<MainMenu/>}></Route>
                <Route path={'/drinks'} element={<Drinks/>}></Route>
                <Route path={'/fastfood'} element={<FastFood/>}></Route>
                <Route path={'/alcohol'} element={<Alcohol/>}></Route>
            </Routes>
        </AnimatePresence>
    );
};

export default AnimRoutes;